import {
    FETCH_ADMIN_ORGANIZATIONS_LIST_REQUEST,
    FETCH_ADMIN_ORGANIZATIONS_LIST_SUCCESS,
    FETCH_ADMIN_ORGANIZATIONS_LIST_FAIL,
    OrganizationsState,
    OrganizationsActionTypes,
    FETCH_MEMBER_ORGANIZATIONS_LIST_FAIL,
    FETCH_MEMBER_ORGANIZATIONS_LIST_REQUEST,
    FETCH_MEMBER_ORGANIZATIONS_LIST_SUCCESS,
} from './types';

const initialState = {
    adminOrganizations: {
        data: [],
        isFailed: false,
        isLoading: false,
    },
    memberOrganizations: {
        data: [],
        isFailed: false,
        isLoading: false,
    },
};

const reducer = (state: OrganizationsState = initialState, action: OrganizationsActionTypes) => {
    switch (action.type) {
        case FETCH_ADMIN_ORGANIZATIONS_LIST_REQUEST:
            return {
                ...state,
                adminOrganizations: {
                    ...state.adminOrganizations,
                    isLoading: true,
                    isFailed: false,
                },
            };

        case FETCH_ADMIN_ORGANIZATIONS_LIST_SUCCESS:
            return {
                ...state,
                adminOrganizations: {
                    ...state.adminOrganizations,
                    data: action.payload.data,
                    isLoading: false,
                    isFailed: false,
                },
            };

        case FETCH_ADMIN_ORGANIZATIONS_LIST_FAIL:
            return {
                ...state,
                adminOrganizations: {
                    ...state.adminOrganizations,
                    isLoading: false,
                    isFailed: true,
                },
            };

        case FETCH_MEMBER_ORGANIZATIONS_LIST_REQUEST:
            return {
                ...state,
                memberOrganizations: {
                    ...state.memberOrganizations,
                    isLoading: true,
                    isFailed: false,
                },
            };

        case FETCH_MEMBER_ORGANIZATIONS_LIST_SUCCESS:
            return {
                ...state,
                memberOrganizations: {
                    ...state.memberOrganizations,
                    data: action.payload.data,
                    isLoading: false,
                    isFailed: false,
                },
            };

        case FETCH_MEMBER_ORGANIZATIONS_LIST_FAIL:
            return {
                ...state,
                memberOrganizations: {
                    ...state.memberOrganizations,
                    isLoading: false,
                    isFailed: true,
                },
            };

        default:
            return state;
    }
};

export default reducer;
